/* Lara chat (snippets/lara-chat.liquid provides window.LARA_CONFIG). Oct 2026. */
(function () {
  'use strict';
  if (window.LaraChat) return;

  var CFG = window.LARA_CONFIG || {};
  var API = CFG.api;
  var LOGO = CFG.logo;
  var AVATAR = CFG.avatar || '';   // Lara's portrait (Shopify Files URL); falls back to the logo
  var REPLY_TIME = CFG.replyTime || '';
  var CARE_EMAIL = 'care@heyhoney.com';
  var PRODUCT = CFG.product || null;
  var CUSTOMER = CFG.customer || { loggedIn: false };
  var STORE = CFG.store || {};
  var PICKS = (CFG.picks || []).filter(function (p) { return p && p.img; }).slice(0, 2);

  // Elements
  var root = document.getElementById('lara-root');
  if (!root) return;
  if (root.parentNode !== document.body) document.body.appendChild(root);
  var launcher = root.querySelector('.lara-launcher');
  var backdrop = root.querySelector('.lara-backdrop');
  var panel = root.querySelector('.lara-panel');
  var bodyEl = panel.querySelector('.lara-body');
  var welcome = panel.querySelector('.lara-welcome');
  var msgs = panel.querySelector('.lara-msgs');
  var hist = panel.querySelector('.lara-hist');
  var form = panel.querySelector('.lara-compose');
  var input = panel.querySelector('#lara-input');
  var sendBtn = panel.querySelector('.lara-send');
  var fileIn = panel.querySelector('input[type="file"]');
  var attBox = panel.querySelector('.lara-att');
  var idSub = panel.querySelector('.lara-id-sub');

  // State
  var history = [];          // [{role, content}] sent to the AI
  var sessionId = null;
  var busy = false;
  var isOpen = false;
  var mode = 'float';        // float | inline
  var expanded = false;
  var attachment = null;     // { mediaType, data, url }
  var inlineSlot = null;
  var lastFocus = null;
  var SS = 'lara_current';
  var LS = 'lara_sessions';

  // Helpers
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function time(d) { try { return (d ? new Date(d) : new Date()).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }); } catch (e) { return ''; } }
  function day(d) { try { return new Date(d).toLocaleDateString([], { month: 'short', day: 'numeric' }); } catch (e) { return ''; } }
  function weekday(d) { try { return new Date(d).toLocaleDateString([], { weekday: 'long', month: 'short', day: 'numeric' }); } catch (e) { return ''; } }
  function isPhone() { return window.matchMedia('(max-width: 640px)').matches; }
  function store(k, v, local) { try { (local ? localStorage : sessionStorage).setItem(k, JSON.stringify(v)); } catch (e) {} }
  function load(k, local) { try { return JSON.parse((local ? localStorage : sessionStorage).getItem(k) || 'null'); } catch (e) { return null; } }
  function post(path, body) {
    return fetch(API + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  }
  function scrollEnd() { bodyEl.scrollTop = bodyEl.scrollHeight; }
  function scrollTo(el) { bodyEl.scrollTop = Math.max(0, el.offsetTop - bodyEl.offsetTop - 8); }

  var ICON_PERSON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/></svg>';
  var ICON_OUT = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17L17 7"/><path d="M8 7h9v9"/></svg>';

  // Markdown-lite: bold, italic, bullet lists, safe links (site paths and heyhoney.com only)
  function inlineMd(s) {
    return s
      .replace(/\[([^\]]+)\]\(((?:https?:\/\/(?:www\.)?heyhoney\.com)?\/[^)\s]*)\)/g, '<a href="$2">$1</a>')
      .replace(/(^|[\s(])(\/(?:policies|products|pages|collections|account)\/[A-Za-z0-9\-\/]+)/g, '$1<a href="$2">$2</a>')
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>');
  }
  function md(text) {
    var out = [], list = false;
    String(text || '').split('\n').forEach(function (line) {
      var t = line.trim();
      if (/^[-*•]\s+/.test(t)) { if (!list) { out.push('<ul>'); list = true; } out.push('<li>' + inlineMd(esc(t.replace(/^[-*•]\s+/, ''))) + '</li>'); return; }
      if (list) { out.push('</ul>'); list = false; }
      if (t) out.push('<p>' + inlineMd(esc(t)) + '</p>');
    });
    if (list) out.push('</ul>');
    return out.join('');
  }

  // Pull Lara's control tags out of a reply
  var TAG_RE = /\[(?:ORDER_LOOKUP|HANDOFF:[^\]]*|PRODUCT:[^\]]*)\]/g;
  function parseReply(full) {
    var res = { order: /\[ORDER_LOOKUP\]/.test(full), handoff: null, products: [], text: '', post: '' };
    var h = full.match(/\[HANDOFF:([A-Za-z]+)\|?([^\]]*)\]/);
    if (h) res.handoff = { category: h[1], summary: (h[2] || '').trim() };
    var lines = full.split('\n'), out = [], after = [], step = '';
    for (var i = 0; i < lines.length; i++) {
      var t = lines[i].trim();
      var ph = t.match(/^\[PRODUCT:"?([^\]"]+)"?\]$/);
      if (/^#{1,4}\s*/.test(t)) { step = t.replace(/^#{1,4}\s*/, ''); continue; }
      if (ph) {
        var reason = [];
        for (var j = i + 1; j < lines.length && j < i + 4; j++) {
          var n = lines[j].trim();
          if (!n || n.charAt(0) === '[' || n.charAt(0) === '#') break;
          reason.push(n);
        }
        var key = ph[1].trim();
        var isHandle = /^[a-z0-9][a-z0-9\-]*$/.test(key);
        res.products.push({ handle: isHandle ? key : '', title: isHandle ? '' : key, step: step, reason: reason.join(' ').replace(/\*\*/g, '') });
        step = ''; i += reason.length; continue;
      }
      (res.products.length ? after : out).push(lines[i]);
    }
    var clean = function (a) { return a.join('\n').replace(TAG_RE, '').replace(/\n{3,}/g, '\n\n').trim(); };
    res.text = clean(out); res.post = clean(after);
    if (!res.products.length) res.post = '';
    return res;
  }
  function streamingText(full) {
    return full.replace(TAG_RE, '').replace(/\[[A-Z_]*[^\]\n]*$/, '').replace(/^#{1,4}\s*/gm, '').trim();
  }

  // Welcome
  function buildWelcome() {
    var intro = panel.querySelector('.lara-intro');
    var who = CFG.introText || "I'm Lara, your AI skincare advisor.";   // editable in lara-chat.liquid (lara_intro_text)
    if (PRODUCT) {
      intro.innerHTML = esc(who) + " Ask me anything about <strong>" + esc(PRODUCT.title.split(' - ')[0]) + "</strong>: how to use it, what's inside, or how it fits your routine.";
    } else {
      intro.textContent = who + " " + (CFG.introMore || "Ask me about ingredients, your routine, or where your order is.");
    }
    panel.querySelector('.lara-polas').innerHTML = PICKS.map(function (p) {
      return '<button type="button" class="lara-pola" data-l="send" data-text="' + esc('Tell me about ' + p.title) + '"><img src="' + esc(p.img) + '" alt="" loading="lazy"><span>' + esc(p.title) + '</span></button>';
    }).join('');
    var chips = PRODUCT
      ? [['send', 'What are the benefits?'], ['send', 'How do I use it?'], ['send', 'Key ingredients?'], ['quiz', 'Build my routine', 1]]
      : [['order', 'Track my order'], ['quiz', 'Build my routine'], ['send', 'Calm my redness', 0, 'I have redness-prone, sensitive skin. What should I use?'], ['send', 'Return policy', 0, "What's your return policy?"]];
    panel.querySelector('.lara-welcome-chips').innerHTML = chips.map(chipHTML).join('');
    loadPromos();
  }

  // Live promotions (managed in the Lara admin dashboard): banner card + "Any promotions?" chip
  var PROMO_CACHE_KEY = 'lara_promos_v1';
  function loadPromos() {
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(PROMO_CACHE_KEY) || 'null'); } catch (e) {}
    if (cached && cached.t && Date.now() - cached.t < 5 * 60 * 1000) { renderPromos(cached.p); return; }
    fetch(API + '/api/promotions').then(function (r) { return r.ok ? r.json() : { promotions: [] }; }).then(function (d) {
      var p = (d && d.promotions) || [];
      try { sessionStorage.setItem(PROMO_CACHE_KEY, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {}
      renderPromos(p);
    }).catch(function () { renderPromos([]); });
  }
  function renderPromos(promos) {
    var slot = panel.querySelector('.lara-promo');
    var chipsEl = panel.querySelector('.lara-welcome-chips');
    if (!slot) return;
    var old = chipsEl.querySelector('[data-promo-chip]'); if (old) old.remove();
    slot.innerHTML = '';
    if (!promos || !promos.length) return;
    var b = null;
    for (var i = 0; i < promos.length; i++) { if (promos[i].banner) { b = promos[i]; break; } }
    if (b) {
      var ask = 'Any promotions?';
      var inner = '<img src="' + esc(b.banner) + '" alt="' + esc(b.title) + '" loading="lazy">'
        + '<span class="lara-promo-t">' + esc(b.title) + (b.code ? ' <em>' + esc(b.code) + '</em>' : '') + '</span>';
      slot.innerHTML = b.link
        ? '<a class="lara-promo-card" href="' + esc(b.link) + '">' + inner + '</a>'
        : '<button type="button" class="lara-promo-card" data-l="send" data-text="' + esc(ask) + '">' + inner + '</button>';
    }
    chipsEl.insertAdjacentHTML('afterbegin', '<button type="button" class="lara-chip" data-l="send" data-promo-chip data-text="Any promotions?">Any promotions?</button>');
  }
  function chipHTML(c) {
    return '<button type="button" class="lara-chip' + (c[2] ? ' lara-solid' : '') + '" data-l="' + c[0] + '" data-text="' + esc(c[3] || c[1]) + '">' + esc(c[1]) + '</button>';
  }
  function showWelcome(show) { welcome.hidden = !show; }

  // Message rendering
  function addUser(text, imgUrl) {
    showWelcome(false);
    var el = document.createElement('div');
    el.className = 'lara-u';
    el.innerHTML = (imgUrl ? '<img class="lara-u-img" src="' + esc(imgUrl) + '" alt="Your photo">' : '')
      + (text ? '<div class="lara-u-b">' + esc(text) + '</div>' : '')
      + '<span class="lara-meta">Sent · ' + time() + '</span>';
    msgs.appendChild(el);
    scrollEnd();
    return el;
  }
  function addBot(html) {
    showWelcome(false);
    var el = document.createElement('div');
    el.className = 'lara-b';
    el.innerHTML = '<div class="lara-b-av' + (AVATAR ? ' lara-b-av-photo' : '') + '"><img src="' + esc(AVATAR || LOGO) + '" alt="Lara"></div><div class="lara-b-c">' + (html || '') + '</div>';
    msgs.appendChild(el);
    scrollTo(el);
    return el.querySelector('.lara-b-c');
  }
  function botMeta(c) { c.insertAdjacentHTML('beforeend', '<span class="lara-meta">Lara · AI · ' + time() + '</span>'); }
  function typing() {
    var c = addBot('<div class="lara-typing" aria-label="Lara is typing"><i></i><i></i><i></i></div>');
    return c.parentNode;
  }

  // Product cards
  function byHandle(h) {
    return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function bySearch(q) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=1')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var hit = ((((d || {}).resources || {}).results || {}).products || [])[0];
        if (!hit) return null;
        return byHandle((hit.url || '').replace(/.*\/products\//, '').split('?')[0]);
      }).catch(function () { return null; });
  }
  function enrich(list) {
    return Promise.all(list.map(function (p) {
      // exact handle first; if Lara guessed a wrong slug, search the store by its words so the card still shows
      var first = p.handle ? byHandle(p.handle) : Promise.resolve(null);
      return first.then(function (d) {
        if (d) return d;
        var q = p.title || p.handle.replace(/-/g, ' ').replace(/\b(cream|serum|gel|mask|the|and|with|a)\b/g, ' ').replace(/\s+/g, ' ').trim();
        return q ? bySearch(q) : null;
      }).then(function (d) { return d ? merge(p, d) : null; }).catch(function () { return null; });
    })).then(function (r) { return r.filter(Boolean); }).then(addRatings);
  }
  // Star ratings from Okendo (public per-product aggregate); cached per product for the session
  var OKENDO = CFG.okendo || '';
  function rating(productId) {
    if (!OKENDO || !productId) return Promise.resolve(null);
    var key = 'lara_rating_' + productId;
    try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && Date.now() - c.t < 6 * 3600 * 1000) return Promise.resolve(c.r); } catch (e) {}
    return fetch('https://api.okendo.io/v1/stores/' + OKENDO + '/products/shopify-' + productId + '/review_aggregate')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var a = d && d.reviewAggregate, lv = a && a.reviewCountByLevel, out = null;
        if (lv) {
          var n = 0, sum = 0;
          for (var i = 1; i <= 5; i++) { var c = Number(lv['level' + i + 'Count'] || 0); n += c; sum += c * i; }
          if (n >= 3) out = { count: n, avg: Math.round(sum / n * 10) / 10 };
        }
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), r: out })); } catch (e) {}
        return out;
      }).catch(function () { return null; });
  }
  function addRatings(list) {
    return Promise.all(list.map(function (p) { return rating(p.id).then(function (r) { p.rating = r; return p; }); }));
  }
  function starsHTML(r) {
    if (!r) return '';
    var pct = Math.round(r.avg / 5 * 100);
    return '<div class="lara-stars" aria-label="' + r.avg + ' out of 5 stars, ' + r.count + ' reviews"><span class="lara-stars-bg"><span class="lara-stars-fg" style="width:' + pct + '%"></span></span><span class="lara-stars-t">' + r.avg + ' (' + r.count.toLocaleString() + ')</span></div>';
  }
  function merge(p, d) {
    var v = (d.variants || []).filter(function (x) { return x.available; })[0] || (d.variants || [])[0] || {};
    return { id: d.id, handle: d.handle, title: d.title, url: '/products/' + d.handle, image: d.featured_image ? (d.featured_image.indexOf('//') === 0 ? 'https:' + d.featured_image : d.featured_image) : '',
      price: '$' + ((v.price || d.price || 0) / 100).toFixed(2), variantId: v.id || null, available: v.available !== false, step: p.step, reason: p.reason };
  }
  function cardsHTML(list) {
    return '<div class="lara-cards">' + list.map(function (p) {
      return '<article class="lara-card">'
        + (p.step ? '<div class="lara-card-step">' + esc(p.step) + '</div>' : '')
        + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<div class="lara-card-ph"></div>')
        + '<div class="lara-card-b"><div class="lara-card-n">' + esc(p.title) + '</div>' + starsHTML(p.rating)
        + (p.reason ? '<p class="lara-card-r">' + esc(p.reason) + '</p>' : '')
        + '<div class="lara-card-f"><span>' + esc(p.price) + '</span><a href="' + esc(p.url) + '">View</a></div>'
        + (p.variantId && p.available ? '<button type="button" class="lara-btn" data-l="atc" data-variant="' + esc(p.variantId) + '">Add to bag</button>'
          : '<a class="lara-btn-o" href="' + esc(p.url) + '">See options</a>')
        + '</div></article>';
    }).join('') + '</div>';
  }
  function addToCart(btn) {
    var id = btn.getAttribute('data-variant');
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        btn.textContent = 'Added to bag';
        if (sessionId) { try { post('/api/event', { type: 'add_to_cart', sessionId: sessionId, productId: id }); } catch (e) {} }
        tagCart(true);
        return fetch('/cart.js').then(function (r2) { return r2.json(); }).then(function (cart) {
          ['[data-cart-count]', '[data-cart-item-count]', '[data-cart-counter]', '.cart-count', '.cart__count', '.cart-count-bubble', '#cart-count', '.js-cart-count', '.header__cart-count']
            .forEach(function (sel) { document.querySelectorAll(sel).forEach(function (el) { el.textContent = cart.item_count; if (cart.item_count > 0) el.removeAttribute('hidden'); }); });
          ['cart:refresh', 'cart:updated', 'theme:cart:updated'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } })); });
        });
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add to bag'; })
      .then(save);
  }

  // Chat with the AI
  function payload() {
    return {
      sessionId: sessionId,
      messages: history.slice(-10),
      product: PRODUCT,
      customer: CUSTOMER.loggedIn ? { id: CUSTOMER.id, name: CUSTOMER.name, fullName: CUSTOMER.fullName, email: CUSTOMER.email, previousProducts: CUSTOMER.previousProducts } : null,
      store: { page: location.pathname, refundPolicy: STORE.refundPolicy, shippingPolicy: STORE.shippingPolicy }
    };
  }
  function ask(text, opts) {
    opts = opts || {};
    if (busy) return;
    var img = attachment;
    if (!text && !img) return;
    busy = true; updateSend();
    if (!opts.silent) addUser(text, img && img.url);
    var content = img ? [{ type: 'image', source: { type: 'base64', media_type: img.mediaType, data: img.data } }, { type: 'text', text: text || 'What do you see in this photo?' }] : text;
    history.push({ role: 'user', content: content });
    clearAttachment();
    var tw = typing();
    var body = payload();
    // never resend a photo on later turns
    history[history.length - 1] = { role: 'user', content: img ? '[photo attached] ' + (text || '') : text };
    post('/api/chat', body).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      tw.remove();
      var c = addBot('<div class="lara-text"></div>');
      return stream(res, c);
    }).catch(function (err) {
      tw.remove();
      var c = addBot('<div class="lara-text"><p>Sorry, I lost my connection for a moment. Please try again.</p></div>');
      botMeta(c);
      console.error('[Lara]', err);
    }).then(function () { busy = false; updateSend(); save(); if (!isPhone()) input.focus(); });
  }
  function stream(res, c) {
    var textEl = c.querySelector('.lara-text');
    if ((res.headers.get('content-type') || '').indexOf('text/event-stream') === -1) {
      return res.json().then(function (d) { return finish(d.message || d.reply || '', c); });
    }
    var reader = res.body.getReader(), dec = new TextDecoder(), buf = '', full = '';
    return new Promise(function (resolve) {
      function pump() {
        reader.read().then(function (chunk) {
          if (chunk.done) { resolve(finish(full, c)); return; }
          buf += dec.decode(chunk.value, { stream: true });
          var lines = buf.split('\n'); buf = lines.pop();
          for (var i = 0; i < lines.length; i++) {
            var l = lines[i];
            if (l.indexOf('data: ') !== 0) continue;
            var raw = l.slice(6).trim();
            if (raw === '[DONE]') continue;
            try {
              var o = JSON.parse(raw);
              if (o.sessionId) { sessionId = o.sessionId; remember(); tagCart(); continue; }
              if (o.error) { full = full || "Sorry, I'm having trouble answering right now. Please try again in a moment."; continue; }
              if (o.text) { full += o.text; textEl.innerHTML = md(streamingText(full)); scrollEnd(); }
            } catch (e) {}
          }
          pump();
        }).catch(function () { resolve(finish(full, c)); });
      }
      pump();
    });
  }
  function finish(full, c) {
    history.push({ role: 'assistant', content: full });
    var r = parseReply(full);
    c.querySelector('.lara-text').innerHTML = md(r.text);
    var after = function () { botMeta(c); save(); };
    if (r.products.length) {
      return enrich(r.products).then(function (list) {
        if (list.length) c.insertAdjacentHTML('beforeend', cardsHTML(list));
        if (r.post) c.insertAdjacentHTML('beforeend', '<div class="lara-text">' + md(r.post) + '</div>');
        after();
        if (r.order) orderLookup();
        else if (r.handoff) handoffForm(r.handoff);
      });
    }
    after();
    if (r.order) orderLookup();
    else if (r.handoff) handoffForm(r.handoff);
  }

  // Orders
  function orderLookup() {
    if (CUSTOMER.loggedIn && CUSTOMER.token) return runLookup({ customerId: String(CUSTOMER.id), customerToken: CUSTOMER.token });
    var c = addBot('<div class="lara-text"><p>Happy to check. What email and order number did you use? Your order number is in your confirmation email.</p></div>'
      + '<form class="lara-box lara-form" data-form="order" novalidate>'
      + '<label>Email<input type="email" name="email" autocomplete="email" required></label>'
      + '<label>Order number<input type="text" name="order" inputmode="numeric" placeholder="e.g. 496642" required></label>'
      + '<p class="lara-err" hidden></p>'
      + '<button type="submit" class="lara-btn">Find my order</button></form>');
    botMeta(c); save();
    var f = c.querySelector('input'); if (f && !isPhone()) f.focus();
  }
  function runLookup(body, formEl) {
    var tw = typing();
    return post('/api/order-status', body).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) { d._status = r.status; return d; });
    }).then(function (d) {
      tw.remove();
      if (formEl && formEl.parentNode) formEl.remove();
      showOrders(d, body);
    }).catch(function () { tw.remove(); showOrders({ _status: 0 }, body); }).then(save);
  }
  var STATUS = { processing: 'Preparing', shipped: 'Shipped', in_transit: 'In transit', out_for_delivery: 'Out for delivery', delivered: 'Delivered', problem: 'Delivery issue', cancelled: 'Cancelled' };
  function showOrders(d, req) {
    var c;
    if (d._status === 429) { c = addBot('<div class="lara-text"><p>That was a few too many lookups. Please try again in a little while, or I can pass this to the team.</p></div>' + humanBtn('Order', 'Order lookup', req.orderNumber)); botMeta(c); return; }
    if (d._status !== 200) {
      c = addBot('<div class="lara-text"><p>I can\'t reach our order system right now. You can see your orders under <a href="/account">your account</a>, or I can pass this to the team.</p></div>' + humanBtn('Order', 'Needs an order status', req.orderNumber));
      botMeta(c); return;
    }
    if (!d.found || !d.orders || !d.orders.length) {
      c = addBot('<div class="lara-text"><p>' + (CUSTOMER.loggedIn ? 'I couldn\'t find any recent orders on your account.' : 'I couldn\'t find an order with that email and order number.') + '</p></div>'
        + '<div class="lara-chips">' + (CUSTOMER.loggedIn ? '' : chipHTML(['order', 'Try again'])) + '<button type="button" class="lara-chip" data-l="human" data-cat="Order" data-sum="Can\'t find their order" data-order="' + esc(req.orderNumber || '') + '">Talk to a person</button></div>');
      botMeta(c); return;
    }
    var o = d.orders[0];
    var lead;
    if (o.needsHuman) lead = 'I found order <strong>' + esc(o.name) + '</strong>, but ' + esc(o.reason.charAt(0).toLowerCase() + o.reason.slice(1)) + ', so I can\'t give you a reliable status. I\'ll pass it to the Hey Honey team so a person can check it.';
    else if (o.status === 'delivered') lead = 'Your order <strong>' + esc(o.name) + '</strong> was delivered' + (o.deliveredAt ? ' on <strong>' + esc(weekday(o.deliveredAt)) + '</strong>' : '') + '.';
    else if (o.status === 'processing') lead = 'Your order <strong>' + esc(o.name) + '</strong> is being prepared. You\'ll get tracking by email as soon as it ships.';
    else if (o.status === 'cancelled') lead = 'Order <strong>' + esc(o.name) + '</strong> was cancelled.';
    else lead = 'Found it. Your order is on its way' + (o.estimatedDeliveryAt ? ' and should arrive <strong>' + esc(weekday(o.estimatedDeliveryAt)) + '</strong>' : '') + '.';
    c = addBot('<div class="lara-text"><p>' + lead + '</p></div>' + orderCard(o));
    var others = d.orders.slice(1).filter(function (x) { return x.status !== 'delivered' && x.status !== 'cancelled'; });
    if (others.length) c.insertAdjacentHTML('beforeend', '<div class="lara-chips">' + others.map(function (x) {
      return '<button type="button" class="lara-chip" data-l="showorder" data-json="' + esc(JSON.stringify(x)) + '">Order ' + esc(x.name) + '</button>';
    }).join('') + '</div>');
    if (!o.needsHuman) c.insertAdjacentHTML('beforeend', '<div class="lara-chips"><button type="button" class="lara-chip" data-l="human" data-cat="Order" data-sum="Problem with order ' + esc(o.name) + '" data-order="' + esc(o.name) + '">Something\'s wrong</button></div>');
    botMeta(c);
    if (o.needsHuman) handoffForm({ category: 'Order', summary: o.reason, orderNumber: o.name, email: req.email });
  }
  function orderCard(o) {
    var n = o.items.reduce(function (s, i) { return s + (i.quantity || 1); }, 0);
    var steps = [
      ['Ordered', o.createdAt, true],
      ['Shipped' + (o.carrier ? ', ' + o.carrier : ''), o.shippedAt, !!o.shippedAt],
      [o.status === 'out_for_delivery' ? 'Out for delivery' : 'In transit', o.inTransitAt, !!o.inTransitAt || o.status === 'out_for_delivery'],
      ['Delivered', o.deliveredAt || o.estimatedDeliveryAt, !!o.deliveredAt]
    ];
    var nowIdx = -1;   // the last step reached is "now"; delivered means everything is done
    for (var i = 0; i < steps.length; i++) if (steps[i][2]) nowIdx = i;
    if (o.deliveredAt) nowIdx = -1;
    var html = '<article class="lara-box"><div class="lara-row"><div><div class="lara-ord-n">Order ' + esc(o.name) + '</div>'
      + '<div class="lara-ord-s">Placed ' + esc(day(o.createdAt)) + ' · ' + n + ' item' + (n === 1 ? '' : 's') + (o.total ? ' · ' + esc(o.total) : '') + '</div></div>'
      + '<span class="lara-pill">' + esc(STATUS[o.status] || o.status) + '</span></div>';
    if (o.items.length) html += '<div class="lara-thumbs">' + o.items.slice(0, 6).map(function (i) { return '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" title="' + esc(i.title) + '">'; }).join('') + '</div>';
    if (o.status !== 'cancelled') {
      html += '<div class="lara-steps">' + steps.map(function (s, i) {
        var cls = i === nowIdx ? 'lara-now' : (s[2] ? 'lara-done' : 'lara-todo');
        var when = s[1] ? (i === 3 && !o.deliveredAt ? 'Est. ' + day(s[1]) : day(s[1])) : '';
        return '<div class="lara-step ' + cls + '"><div class="lara-step-rail"><span class="lara-dot"></span>' + (i < 3 ? '<span class="lara-line"></span>' : '') + '</div>'
          + '<div class="lara-step-t"><span>' + esc(s[0]) + '</span><span>' + esc(when) + '</span></div></div>';
      }).join('') + '</div>';
    }
    if (o.trackingUrl) html += '<a class="lara-btn-o" href="' + esc(o.trackingUrl) + '" target="_blank" rel="noopener">Track on ' + esc(o.carrier || 'carrier') + ' ' + ICON_OUT + '</a>';
    return html + '</article>';
  }

  // Handoff to a person
  function humanBtn(cat, sum, order) {
    return '<div class="lara-chips"><button type="button" class="lara-chip" data-l="human" data-cat="' + esc(cat) + '" data-sum="' + esc(sum) + '" data-order="' + esc(order || '') + '">Talk to a person</button></div>';
  }
  function handoffForm(h) {
    var cats = ['Order', 'Product', 'Return', 'Wholesale', 'Other'];
    var cat = cats.indexOf(h.category) >= 0 ? h.category : 'Other';
    var email = h.email || CUSTOMER.email || '';
    var c = addBot('<form class="lara-box lara-form" data-form="handoff" data-cat="' + cat + '" novalidate>'
      + '<p style="font-size:15px;font-weight:700">Send this to the Hey Honey team</p>'
      + '<label>Your name<input type="text" name="name" autocomplete="name" value="' + esc(CUSTOMER.fullName || '') + '"></label>'
      + '<label>Email for the reply<input type="email" name="email" autocomplete="email" required value="' + esc(email) + '"></label>'
      + (cat === 'Order' || cat === 'Return' ? '<label>Order number<input type="text" name="order" value="' + esc(h.orderNumber || '') + '"></label>' : '')
      + '<label>What\'s going on?<textarea name="summary" maxlength="200" required>' + esc(h.summary || '') + '</textarea></label>'
      + '<p class="lara-err" hidden></p>'
      + '<button type="submit" class="lara-btn">Send to the team</button>'
      + '<p class="lara-fine">The team sees this whole chat, so you won\'t need to repeat yourself.</p></form>');
    save();
    return c;
  }
  function sendHandoff(f) {
    var err = f.querySelector('.lara-err');
    var email = (f.email.value || '').trim(), summary = (f.summary.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'Please enter a valid email.'; err.hidden = false; return; }
    if (!summary) { err.textContent = 'Please add a short note.'; err.hidden = false; return; }
    var data = { sessionId: sessionId, email: email, name: (f.name.value || '').trim(), category: f.getAttribute('data-cat'),
      summary: summary, orderNumber: f.order ? f.order.value.trim() : '', pageUrl: location.href,
      transcript: transcript() };
    var btn = f.querySelector('button[type="submit"]'); btn.disabled = true; btn.textContent = 'Sending...';
    post('/api/handoff', data).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }).then(function () {
      f.outerHTML = '<article class="lara-box lara-strong"><div style="display:flex;gap:10px;align-items:center"><span class="lara-person">' + ICON_PERSON + '</span>'
        + '<div><div class="lara-ord-n">Sent to the Hey Honey team</div><div class="lara-ord-s">You\'ll get a reply by email</div></div></div>'
        + '<div class="lara-sum">' + (data.orderNumber ? '<div><span>Order</span><span>' + esc(data.orderNumber) + '</span></div>' : '')
        + '<div><span>Issue</span><span>' + esc(summary) + '</span></div><div><span>Reply to</span><span>' + esc(mask(email)) + '</span></div>'
        + (REPLY_TIME ? '<div><span>Typical reply</span><span>' + esc(REPLY_TIME) + '</span></div>' : '') + '</div>'
        + '<p class="lara-fine">The team sees this whole chat, so you won\'t need to repeat yourself.</p></article>'
        + '<div class="lara-wait">Waiting for a person. Lara can still help with products in the meantime.</div>';
      save();
    }).catch(function () {
      var subject = encodeURIComponent('[Lara · ' + data.category + '] ' + summary);
      var mbody = encodeURIComponent(summary + (data.orderNumber ? '\nOrder: ' + data.orderNumber : '') + '\n\n(sent from the Hey Honey chat)');
      f.outerHTML = '<div class="lara-box"><p>I couldn\'t send that automatically. Please email the team and they\'ll get back to you:</p>'
        + '<a class="lara-btn-o" href="mailto:' + CARE_EMAIL + '?subject=' + subject + '&body=' + mbody + '">Email ' + CARE_EMAIL + '</a></div>';
      save();
    });
  }
  // What the shopper saw in this chat (includes order lookups the AI never saw), for the team's email
  function transcript() {
    return [].map.call(msgs.querySelectorAll('.lara-u, .lara-b'), function (el) {
      var isUser = el.classList.contains('lara-u');
      var clone = el.cloneNode(true);
      clone.querySelectorAll('.lara-meta, form, button, .lara-q').forEach(function (x) { x.remove(); });
      return { role: isUser ? 'user' : 'assistant', content: clone.innerText.replace(/\n{2,}/g, '\n').trim().slice(0, 1500) };
    }).filter(function (m) { return m.content; }).slice(-30);
  }
  function mask(e) { var p = e.split('@'); return p[0].charAt(0) + '•••@' + p[1]; }

  // Routine quiz
  function quiz() {
    var ans = { goals: [], skin: '', age: '', style: '' };
    var steps = [
      { k: 'goals', t: 'I want results:', s: 'Pick up to 3', multi: 3, o: ['Reduce fine lines', 'Firm & lift', 'Plump', 'Brighten', 'Even skin tone', 'Reduce dullness', 'Fight dryness', 'Reduce oiliness', 'Reduce pores', 'Master texture', 'Fight breakouts', 'Calm rosacea', 'Eye puffiness', 'Eye area lines'] },
      { k: 'skin', t: 'My skin type:', s: 'Pick one', o: ['Dry', 'Oily', 'Combination', 'Normal', 'Sensitive'] },
      { k: 'age', t: 'My age range:', s: 'Helps match the right actives', one: 1, o: ['20s, prevention', '30s, early correction', '40s, firming and repair', '50s+, deep renewal'] },
      { k: 'style', t: 'My routine style:', s: "We'll work with your real life", one: 1, o: ['Quick, 3 steps max', 'Normal, 5 to 6 steps', 'Full ritual, I love my routine'] }
    ];
    var i = 0;
    addUser('Build my routine');
    var c = addBot('<div class="lara-q"></div>');
    var q = c.querySelector('.lara-q');
    function render() {
      var st = steps[i], sel = ans[st.k];
      q.innerHTML = '<div class="lara-q-bar"><i style="width:' + Math.round((i + 1) / steps.length * 100) + '%"></i></div>'
        + '<div class="lara-q-k">Step ' + (i + 1) + ' of ' + steps.length + '</div><div class="lara-q-t">' + st.t + ' <span class="lara-meta">' + st.s + '</span></div>'
        + '<div class="lara-q-opts' + (st.one ? ' lara-one' : '') + '">' + st.o.map(function (o) {
          var on = st.multi ? sel.indexOf(o) >= 0 : sel === o;
          return '<button type="button" class="lara-q-o" aria-pressed="' + on + '" data-v="' + esc(o) + '">' + esc(o) + '</button>';
        }).join('') + '</div><button type="button" class="lara-btn lara-q-next"' + ((st.multi ? sel.length : sel) ? '' : ' disabled') + '>' + (i === steps.length - 1 ? 'Build my routine' : 'Next') + '</button>';
    }
    q.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      e.stopPropagation();
      var st = steps[i];
      if (b.classList.contains('lara-q-o')) {
        var v = b.getAttribute('data-v');
        if (st.multi) { var k = ans.goals.indexOf(v); if (k >= 0) ans.goals.splice(k, 1); else if (ans.goals.length < st.multi) ans.goals.push(v); }
        else ans[st.k] = v;
        render(); return;
      }
      if (b.classList.contains('lara-q-next')) {
        if (i < steps.length - 1) { i++; render(); scrollTo(c.parentNode); return; }
        c.parentNode.remove();
        ask('I just completed the routine quiz. Give me my complete personalized Hey Honey routine now with specific product recommendations for each step. Do not ask follow-up questions.\n\nGoals: ' + ans.goals.join(', ') + '.\nSkin type: ' + ans.skin + '.\nAge range: ' + ans.age + '.\nRoutine style: ' + ans.style + '.', { silent: true });
      }
    });
    render();
  }

  // Photos
  function attach(file) {
    if (!file || !/^image\//.test(file.type)) return;
    var img = new Image(), url = URL.createObjectURL(file);
    img.onload = function () {
      var s = Math.min(1, 1024 / Math.max(img.width, img.height));
      var cv = document.createElement('canvas'); cv.width = Math.round(img.width * s); cv.height = Math.round(img.height * s);
      cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
      var dataUrl = cv.toDataURL('image/jpeg', 0.82);
      attachment = { mediaType: 'image/jpeg', data: dataUrl.split(',')[1], url: dataUrl };
      attBox.querySelector('img').src = dataUrl; attBox.hidden = false; updateSend();
      URL.revokeObjectURL(url);
    };
    img.src = url;
  }
  function clearAttachment() { attachment = null; attBox.hidden = true; fileIn.value = ''; updateSend(); }

  // History
  function remember() {
    if (!sessionId) return;
    var list = load(LS, true) || [];
    if (list.some(function (s) { return s.id === sessionId; })) return;
    var first = history.filter(function (m) { return m.role === 'user'; })[0];
    var title = first ? String(typeof first.content === 'string' ? first.content : 'Photo').replace(/^\[photo attached\]\s*/, '').slice(0, 60) : 'Chat';
    if (/^I just completed the routine quiz/.test(title)) title = 'My routine';
    list.unshift({ id: sessionId, title: title, at: new Date().toISOString() });
    store(LS, list.slice(0, 20), true);
  }
  function showHistory() {
    var list = load(LS, true) || [];
    var open = hist.hidden;
    hist.hidden = !open; welcome.hidden = open || msgs.children.length > 0; msgs.hidden = open;
    if (!open) { showWelcome(!msgs.children.length); return; }
    hist.innerHTML = '<p class="lara-q-k">Past chats</p>' + (list.length ? list.map(function (s) {
      return '<button type="button" class="lara-hist-i" data-l="loadchat" data-id="' + esc(s.id) + '"><span>' + esc(s.title) + '</span><span>' + esc(day(s.at)) + '</span></button>';
    }).join('') : '<p class="lara-fine">No past chats yet.</p>');
  }
  function loadChat(id) {
    fetch(API + '/api/session?id=' + encodeURIComponent(id)).then(function (r) { return r.json(); }).then(function (d) {
      reset();
      sessionId = id;
      (d.messages || []).forEach(function (m) {
        if (m.role === 'user') {
          if (/^I just completed the routine quiz/.test(m.content)) return;
          var u = addUser(m.content.replace(/^\[\d? ?photos? attached\]\s*/, ''));
          u.querySelector('.lara-meta').textContent = 'Sent · ' + day(m.createdAt);
        } else {
          var r = parseReply(m.content);
          var c = addBot('<div class="lara-text">' + md(r.text + (r.post ? '\n' + r.post : '')) + '</div>');
          c.insertAdjacentHTML('beforeend', '<span class="lara-meta">Lara · AI · ' + day(m.createdAt) + '</span>');
        }
        history.push({ role: m.role, content: m.content });
      });
      hist.hidden = true; msgs.hidden = false; showWelcome(!msgs.children.length); scrollEnd(); save();
    }).catch(function () {});
  }

  // Persistence across pages
  function save() { store(SS, { sessionId: sessionId, history: history, html: msgs.innerHTML }); }
  function restore() {
    var d = load(SS);
    if (!d || !d.html) return;
    sessionId = d.sessionId || null; history = d.history || [];
    msgs.innerHTML = d.html;
    msgs.querySelectorAll('.lara-q, .lara-typing').forEach(function (el) { var m = el.closest('.lara-b'); if (m) m.remove(); });
    showWelcome(!msgs.children.length);
  }
  function reset() {
    history = []; sessionId = null; msgs.innerHTML = ''; clearAttachment();
    try { sessionStorage.removeItem(SS); } catch (e) {}
    hist.hidden = true; msgs.hidden = false; showWelcome(true);
  }

  // Order attribution: tag the Shopify cart with the chat session so the order webhook can match it
  var taggedSession = null;
  function tagCart(force) {
    if (!sessionId || (!force && taggedSession === sessionId)) return;
    taggedSession = sessionId;
    try {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { lara_session: sessionId } }) }).catch(function () {});
    } catch (e) {}
  }

  // First-visit teaser: a small card by the Chat button, once per visitor, not on product/cart/checkout pages
  var TEASER_KEY = 'lara_teaser_seen';
  function teaser() {
    var t = CFG.teaser;
    if (!t || !t.enabled) return;
    if (PRODUCT || /^\/(cart|checkouts?|account)/.test(location.pathname)) return;
    try { if (localStorage.getItem(TEASER_KEY)) return; } catch (e) {}
    setTimeout(function () {
      if (isOpen) return;
      try { localStorage.setItem(TEASER_KEY, '1'); } catch (e) {}
      var el = document.createElement('div');
      el.className = 'lara-teaser lara-scope';
      el.setAttribute('role', 'status');
      el.innerHTML = '<button type="button" class="lara-teaser-x" aria-label="Dismiss">×</button>'
        + '<button type="button" class="lara-teaser-body">'
        + (t.video ? '<video class="lara-teaser-media" src="' + esc(t.video) + '"' + (t.poster || AVATAR ? ' poster="' + esc(t.poster || AVATAR) + '"' : '') + ' muted playsinline autoplay loop></video>'
           : AVATAR ? '<img class="lara-teaser-media" src="' + esc(AVATAR) + '" alt="">'
                    : '<span class="lara-teaser-media lara-teaser-logo"><img src="' + esc(LOGO) + '" alt=""></span>')
        + '<span class="lara-teaser-text"><strong>' + esc(t.title || 'Hi, I\'m Lara.') + '</strong>' + esc(t.text || "I'm here if you have any questions.") + '</span></button>';
      root.appendChild(el);
      requestAnimationFrame(function () { el.classList.add('lara-teaser-in'); });
      var remove = function () { el.classList.remove('lara-teaser-in'); setTimeout(function () { el.remove(); }, 250); };
      el.querySelector('.lara-teaser-x').addEventListener('click', remove);
      el.querySelector('.lara-teaser-body').addEventListener('click', function () {
        remove();
        open('float', null, launcher);
        if (t.video) introVideo(t);
      });
      setTimeout(function () { if (document.body.contains(el)) remove(); }, (t.seconds || 20) * 1000);
    }, (t.delay || 8) * 1000);
  }
  // Full intro video at the top of the welcome screen (plays with sound because the visitor tapped)
  function introVideo(t) {
    var slot = panel.querySelector('.lara-intro-video');
    if (!slot || !t.video) return;
    var poster = t.poster || AVATAR;
    slot.innerHTML = '<video src="' + esc(t.video) + '"' + (poster ? ' poster="' + esc(poster) + '"' : '') + ' playsinline autoplay></video>'
      + (t.badge ? '<div class="lara-intro-badge"><strong>' + esc(t.badgeName || 'Lara') + '</strong><span>' + esc(t.badgeRole || 'AI Beauty Advisor') + '</span></div>' : '')
      + '<button type="button" class="lara-intro-x" aria-label="Skip video">×</button>';
    slot.hidden = false;
    var v = slot.querySelector('video');
    var done = function () { try { v.pause(); } catch (e) {} slot.hidden = true; slot.innerHTML = ''; };
    v.addEventListener('ended', done);
    v.addEventListener('error', done);
    v.addEventListener('click', function () { if (v.paused) v.play().catch(function () {}); else v.pause(); });
    slot.querySelector('.lara-intro-x').addEventListener('click', done);
    v.play().catch(function () {});
  }

  // Open / close / modes
  var openTracked = false;
  function trackOpen() {
    if (openTracked) return; openTracked = true;
    try { post('/api/event', { type: 'widget_open', productTitle: PRODUCT ? PRODUCT.title : '', pageUrl: location.pathname, loggedIn: !!CUSTOMER.loggedIn }); } catch (e) {}
  }
  function setMode(m, slot) {
    mode = m;
    if (m === 'inline' && slot) { slot.appendChild(panel); panel.classList.add('lara-inline'); inlineSlot = slot; }
    else { root.appendChild(panel); panel.classList.remove('lara-inline'); }
    idSub.hidden = !PRODUCT;
    if (PRODUCT) idSub.textContent = 'about ' + PRODUCT.title.split(' - ')[0];
    buildWelcome();
  }
  function open(m, slot, trigger) {
    if (expanded) collapse();
    lastFocus = trigger || document.activeElement;
    setMode(isPhone() ? 'float' : (m || 'float'), slot);
    panel.hidden = false; isOpen = true;
    launcher.setAttribute('aria-expanded', 'true'); launcher.hidden = mode === 'float';
    document.querySelectorAll('[data-lara-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', String(mode === 'inline' && t === trigger)); });
    if (isPhone()) { document.documentElement.style.overflow = 'hidden'; try { window.history.pushState({ lara: 1 }, ''); } catch (e) {} }
    trackOpen();
    showWelcome(!msgs.children.length && hist.hidden);
    scrollEnd();
    if (!isPhone()) setTimeout(function () { input.focus(); }, 60);
  }
  function close() {
    if (expanded) collapse();
    panel.hidden = true; isOpen = false;
    launcher.hidden = false; launcher.setAttribute('aria-expanded', 'false');
    document.querySelectorAll('[data-lara-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }
  function expand() {
    expanded = true; root.appendChild(panel); panel.classList.remove('lara-inline'); panel.classList.add('lara-expanded'); backdrop.hidden = false;
    panel.querySelector('[data-l="expand"]').setAttribute('aria-label', 'Make chat smaller'); scrollEnd();
  }
  function collapse() {
    expanded = false; panel.classList.remove('lara-expanded'); backdrop.hidden = true;
    panel.querySelector('[data-l="expand"]').setAttribute('aria-label', 'Expand chat');
    if (mode === 'inline' && inlineSlot && document.body.contains(inlineSlot)) { inlineSlot.appendChild(panel); panel.classList.add('lara-inline'); }
    scrollEnd();
  }

  // Events (delegated, so restored chats keep working)
  function updateSend() { sendBtn.disabled = busy || (!input.value.trim() && !attachment); }
  input.addEventListener('input', updateSend);
  form.addEventListener('submit', function (e) { e.preventDefault(); var t = input.value.trim(); if (sendBtn.disabled) return; input.value = ''; ask(t); });
  fileIn.addEventListener('change', function () { attach(fileIn.files[0]); });
  launcher.addEventListener('click', function () { open('float', null, launcher); });
  backdrop.addEventListener('click', collapse);
  window.addEventListener('popstate', function () { if (isOpen && isPhone()) close(); });
  panel.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.stopPropagation(); if (expanded) collapse(); else close(); return; }
    if (e.key === 'Tab' && (expanded || isPhone() || mode === 'float')) {
      var f = [].filter.call(panel.querySelectorAll('button:not([disabled]), a[href], input:not([type="file"]):not([disabled]), textarea'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  panel.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-form]'); if (!f) return;
    e.preventDefault(); e.stopPropagation();
    if (f.getAttribute('data-form') === 'handoff') return sendHandoff(f);
    var email = (f.email.value || '').trim(), num = (f.order.value || '').replace(/[^0-9]/g, '');
    var err = f.querySelector('.lara-err');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) || !num) { err.textContent = 'Please enter your email and order number.'; err.hidden = false; return; }
    f.querySelector('button').disabled = true;
    runLookup({ email: email, orderNumber: num }, f);
  });
  panel.addEventListener('click', function (e) {
    var b = e.target.closest('[data-l]'); if (!b || !panel.contains(b)) return;
    e.stopPropagation();
    var a = b.getAttribute('data-l');
    if (a === 'close') return close();
    if (a === 'expand') return expanded ? collapse() : expand();
    if (a === 'new') return reset();
    if (a === 'history') return showHistory();
    if (a === 'loadchat') return loadChat(b.getAttribute('data-id'));
    if (a === 'attach') return fileIn.click();
    if (a === 'unattach') return clearAttachment();
    if (busy) return;
    var chips = b.closest('.lara-chips'); if (chips && !chips.classList.contains('lara-welcome-chips')) chips.remove();
    if (a === 'send') return ask(b.getAttribute('data-text'));
    if (a === 'quiz') return quiz();
    if (a === 'order') { addUser(b.textContent.trim()); return orderLookup(); }
    if (a === 'atc') return addToCart(b);
    if (a === 'human') { addUser('Talk to a person'); return handoffForm({ category: b.getAttribute('data-cat'), summary: b.getAttribute('data-sum'), orderNumber: b.getAttribute('data-order') }); }
    if (a === 'showorder') { try { var o = JSON.parse(b.getAttribute('data-json')); botMeta(addBot(orderCard(o))); save(); } catch (x) {} }
  });
  // "Ask Lara" in the site header: any link to #ask-lara opens the chat; if the theme menu has none, add the pill ourselves
  function pillHTML() { return (AVATAR ? '<img src="' + esc(AVATAR) + '" alt="" width="28" height="28">' : '') + '<span>Ask Lara</span>'; }
  function headerPill() {
    var links = [].slice.call(document.querySelectorAll('a[href$="#ask-lara"]'));
    links.forEach(function (a) {
      if (a.classList.contains('lara-nav-pill')) return;
      a.classList.add('lara-nav-pill'); a.setAttribute('aria-haspopup', 'dialog'); a.setAttribute('aria-label', 'Ask Lara, your beauty advisor');
      a.innerHTML = pillHTML();
    });
    var inHeader = links.some(function (a) { return !!a.closest('header'); });
    var desktop = document.querySelector('header .header__links-list, header .header__menu, header nav ul');
    if (!inHeader && desktop && !desktop.querySelector('.lara-nav-pill')) {
      var li = document.createElement('li'); li.className = (desktop.firstElementChild && desktop.firstElementChild.className) || '';
      li.innerHTML = '<a class="lara-nav-pill" href="#ask-lara" aria-haspopup="dialog" aria-label="Ask Lara, your beauty advisor">' + pillHTML() + '</a>';
      desktop.appendChild(li);
    }
    var mobileRow = document.querySelector('header .header__row-mobile');
    if (mobileRow && !mobileRow.querySelector('.lara-nav-pill')) {
      var a = document.createElement('a'); a.className = 'lara-nav-pill lara-nav-pill-mobile'; a.href = '#ask-lara';
      a.setAttribute('aria-haspopup', 'dialog'); a.setAttribute('aria-label', 'Ask Lara, your beauty advisor'); a.innerHTML = pillHTML();
      var segs = mobileRow.children; mobileRow.insertBefore(a, segs.length > 1 ? segs[1] : null);
      mobileRow.style.justifyContent = 'space-between'; mobileRow.style.alignItems = 'center';
    }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="#ask-lara"]'); if (!a) return;
    e.preventDefault();
    if (isOpen && mode === 'float') return close();
    open('float', null, a);
  });

  // Gold "Ask a beauty advisor" buttons on product pages (also the theme's sticky clone)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lara-trigger]'); if (!t) return;
    e.preventDefault();
    var slot = t.parentNode.querySelector('.lara-inline-slot');
    if (isOpen && mode === 'inline' && inlineSlot === slot && !expanded) return close();
    open('inline', slot, t);
  });

  // Init
  function hasPdpTrigger() { return [].some.call(document.querySelectorAll('[data-lara-trigger]'), function (t) { return t.offsetParent !== null; }); }
  // Visitor count for the dashboard funnel: one ping per browser session, no personal data
  function countVisit() {
    try { if (sessionStorage.getItem('lara_visited')) return; sessionStorage.setItem('lara_visited', '1'); } catch (e) { return; }
    setTimeout(function () {
      try { post('/api/event', { type: 'visit', pageUrl: location.pathname, product: !!PRODUCT, loggedIn: !!CUSTOMER.loggedIn }).catch(function () {}); } catch (e) {}
    }, 1500);
  }
  function init() {
    if (hasPdpTrigger()) root.classList.add('lara-has-pdp');
    buildWelcome();
    restore();
    teaser();
    countVisit();
    headerPill();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.LaraChat = { open: function () { open('float', null, launcher); }, close: close, reset: reset };
})();
